@if (displayed) {
<div class="grid-result-footer-wrapper" #gridFooter>
    <!-- load more has not yet been clicked : display the button-->
    @if (!activated) {
    <h-call-to-action
        (click)="handleClick($event)"
        (keypress)="handleKeyPress($event)"
        [appearance]="'secondary'"
        [dataTestId]="'Load more items'"
        i18n="@@hermes-grid-full.load-more-items">
        Load more items
    </h-call-to-action>
    }

    <!-- load more is active : display loader animation-->
    @if (activated && fetchingMore) {
    <div>
        <h-grid-result-loader> </h-grid-result-loader>
    </div>
    }
</div>
}
